var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30.2804,
    height: 30.2804,
    fill: "white",
    fillOpacity: 0.87
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.42527 19.0249C6.1762 19.0249 5.16559 20.0469 5.16559 21.2959C5.16559 22.545 6.1762 23.567 7.42527 23.567C8.67433 23.567 9.69629 22.545 9.69629 21.2959C9.69629 20.0469 8.67433 19.0249 7.42527 19.0249ZM0.612183 0.856689V3.12772H2.88321L6.97106 11.7463L5.43812 14.5283C5.25643 14.8462 5.15424 15.2209 5.15424 15.6184C5.15424 16.8674 6.1762 17.8894 7.42527 17.8894H21.0514V15.6184H7.90218C7.74321 15.6184 7.6183 15.4935 7.6183 15.3345L7.65237 15.1982L8.67433 13.3473H17.1339C17.9855 13.3473 18.735 12.8818 19.1211 12.1778L23.1862 4.80828C23.277 4.64931 23.3225 4.45627 23.3225 4.26323C23.3225 3.6387 22.8115 3.12772 22.1869 3.12772H5.3927L4.32531 0.856689H0.612183ZM18.7804 19.0249C17.5313 19.0249 16.5207 20.0469 16.5207 21.2959C16.5207 22.545 17.5313 23.567 18.7804 23.567C20.0295 23.567 21.0514 22.545 21.0514 21.2959C21.0514 20.0469 20.0295 19.0249 18.7804 19.0249Z",
    fill: "#000C2B",
    fillOpacity: 0.81
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarts);
export default __webpack_public_path__ + "static/media/carts.58ed9036d8bec883563c831987378af2.svg";
export { ForwardRef as ReactComponent };